import { BaseItem, Nullable, NullablePartial } from '../common';

export enum Clearinghouse {
  Availity = 'AVAILITY',
  Waystar = 'WAYSTAR',
  ChangeHealthcare = 'CHANGE_HEALTHCARE',
  Experian = 'EXPERIAN',
  Trizetto = 'TRIZETTO',
  ESolutions = 'E_SOLUTIONS',
}

export enum ClearinghouseService {
  Remittance835 = 'REMITTANCE_835',
  Claim837 = 'CLAIM_837',
  Eligibility270271 = 'ELIGIBILITY_270_271',
  ClaimStatusRequest276277 = 'CLAIM_STATUS_276_277',
  Auths278 = 'AUTHS_278',
}

export type FindAllOptions = NullablePartial<
  Nullable<{
    payorId: string;
    clearinghouse: Clearinghouse;
    clearinghouseService: ClearinghouseService;
  }>
>;

export interface BaseClearinghouse {
  payorId: string;
  clearinghousePayorId: string;
  clearinghouse: Clearinghouse;
  clearinghouseService: ClearinghouseService;
  addressId: string | null;
  phoneNumber: string | null;
  rteResponsePayorName: string | null;
}

export interface PayorClearinghouse extends BaseItem, BaseClearinghouse {}

export type CreateValues = NullablePartial<BaseClearinghouse>;
